import { getCategories, getOrganizatioanApi } from "api";
import { times } from "lodash";
import moment from "moment";
import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import pdfMake from "pdfmake";
import { Button, Card, Container, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
class DeliveryChallan extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    // pdfMake.createPdf(docDefinition).download();
    this.state = {
      organizations: {},
      categoryList: [],
      props: props?.location?.query
        ? props?.location?.query
        : { data: null, isEdit: 1 },
      totalAmount: 0,
      totalPieces: 0,
      totalWeight: 0,
    };
  }
  printPDF = () => {
    pdfMake.fonts = {
      Roboto: {
        normal:
          "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
        bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
        italics:
          "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
        bolditalics:
          "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
      },
    };
    var docDefinition = {
      pageSize: "A4",
      content: [
        {
          table: {
            headerRows: 7,
            widths: ["98%", "2%"],
            body: [
              [
                {
                  colSpan: 2,
                  text: `${data.dataValues.name}`,
                  style: ["f11", "b", "ac"],
                  border: [true, true, true, false],
                  margin: [0, 20, 0, 10],
                },
                "",
              ],
              //   [ {colSpan:2,text:'Professional Real Estate Investor',style:['f16','b','ac'],border: [true, false, true, false]},'' ],
              //   [ {colSpan:2,text:'Active Real Estate Report',style:['f11','b','ac'],border: [true, false, true, false]},'' ],
              [
                {
                  colSpan: 2,
                  text: `${moment(req.body.startDate, "YYYY-MM-DD").format(
                    "MMMM DD YYYY"
                  )} - ${moment(req.body.endDate, "YYYY-MM-DD").format(
                    "MMMM DD YYYY"
                  )}`,
                  style: ["f11", "b", "ac"],
                  border: [true, false, true, false],
                  margin: [0, 0, 0, 10],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  text: [
                    {
                      text: "Total Hours Worked: ",
                      style: ["f11", "al"],
                      border: [true, true, true, false],
                      margin: [0, 10, 0, 10],
                    },
                    {
                      text: `${data.dataValues.totalHrs}`,
                      style: ["f11", "b", "al"],
                      border: [true, true, true, false],
                      margin: [0, 10, 0, 10],
                    },
                  ],
                  margin: [0, 30, 0, 30],
                  border: [true, true, true, false],
                },
                "",
              ],
              [
                {
                  text: "Tasks",
                  style: ["f11", "al"],
                  border: [true, false, false, false],
                  margin: [0, 10, 0, 20],
                },
                {
                  text: "Hrs",
                  style: ["f11", "ar"],
                  border: [false, false, true, false],
                  margin: [0, 0, 0, 20],
                },
              ],
              [
                {
                  colSpan: 2,
                  canvas: [
                    {
                      type: "line",
                      x1: 0,
                      y1: 0,
                      x2: 967,
                      y2: 0,
                      lineWidth: 0.1,
                    },
                  ],
                  margin: [0, 0, 0, 20],
                  border: [true, false, true, false],
                },
                "",
              ],
              ...reportsArray,
            ],
          },
          layout: {
            // hLineWidth: function (i, node) {
            //     return (i === 0 || i === node.table.body.length) ? 2 : 1;
            // },
            // vLineWidth: function (i, node) {
            //     return (i === 0 || i === node.table.widths.length) ? 2 : 1;
            // },
            // hLineColor: function (i, node) {
            //     return (i === 0 || i === node.table.body.length) ? 'black' : 'gray';
            // },
            // vLineColor: function (i, node) {
            //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
            // },
            // hLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function (i, node) {
              return i == 0 ? 50 : 0;
            },
            paddingRight: function (i, node) {
              return i == 0 ? 10 : 50;
            },
            paddingTop: function (i, node) {
              return 2;
            },
            paddingBottom: function (i, node) {
              return 2;
            },
            // fillColor: function (rowIndex, node, columnIndex) { return null; }
          },
        },
      ],
      footer: function (currentPage, pageCount) {
        return [
          {
            text: "Page " + currentPage.toString() + " of " + pageCount,
            style: ["f18", "ac"],
          },
        ];
      },
      styles: {
        b: {
          bold: true,
        },
        f32: {
          fontSize: 32,
        },
        f16: {
          fontSize: 16,
        },
        f20: {
          fontSize: 20,
        },
        f11: {
          fontSize: 11,
        },
        f12: {
          fontSize: 12,
        },
        f14: {
          fontSize: 14,
        },
        f18: {
          fontSize: 18,
        },
        header: {
          fontSize: 22,
        },
        ac: {
          alignment: "center",
        },
        al: {
          alignment: "left",
        },
        ar: {
          alignment: "right",
        },
        anotherStyle: {
          italics: true,
          alignment: "right",
        },
      },
      //Specifying our imported font as default style
      defaultStyle: {
        font: "Roboto",
      },
    };
    //Creating pdf with pdfmake and downloading it
    pdfMake.createPdf(docDefinition).download();
  };

  async componentDidMount() {
    const data = await getOrganizatioanApi();
    const categories = await getCategories();
    console.log(data.data.organizations[0]);
    this.setState({
      organizations: data.data.organizations[0],
      categoryList: categories.data,
    });

    if (this.state.props.data.dataEntryStock) {
      if (this.state.props.data.dataEntryStock.stockDataEntryInWards) {
        let totalPieces = this.state.totalPieces;
        let totalWeight = this.state.totalWeight;
        let totalAmount = this.state.totalAmount;
        this.state.props.data.dataEntryStock.stockDataEntryInWards.map(x => {
          return (
            (totalPieces += parseInt(x.pieces)),
            (totalWeight += parseInt(x.weight)),
            (totalAmount +=
              parseInt(x.weight) *
              this.state.props.data.mainJangad.party.duplicateRate)
          );
        });
        this.setState({
          totalPieces: totalPieces,
          totalWeight: totalWeight,
          totalAmount: totalAmount,
        });
      }
    } else {
      totalPieces = 0;
    }
  }
  render() {
    document.title = `Delivery Challan ${
      this.state.props.data.jangad.id
    } ${moment().format("DD/MM/YYYY")}`;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Delivery Challan" />
            <Card className="pb-5">
              <div>
                <h2 className="fw-bold text-center text-black ">
                  P3Y Diamond Tech
                </h2>
                <div className="border_dark"></div>
                <h5 className="text-center pt-1">
                  {this.state.organizations.addressLine1}{" "}
                  {this.state.organizations.addressLine2}
                </h5>

                <div className="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black d-inline fw-bold"> Email:</h5>
                    <p className="d-inline fs-5 ps-2">
                      {this.state.organizations.email}
                    </p>
                  </div>
                  <div>
                    <h5 className="text-black d-inline fw-bold">GSTIN/UIN:</h5>
                    <p className="d-inline fs-5 ps-2">
                      {this.state.organizations.gstNo}
                    </p>
                  </div>
                </div>

                <div className="border_dark"></div>
                <h4 className="fw-bold text-center py-1 text-black">
                  Delivery Challan
                </h4>
                <div className="border_dark"></div>

                <div className="d-sm-flex d-block text-sm-start text-center justify-content-between ps-md-3 pe-md-5">
                  <div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        {this.props.t("Party Name")}:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.party.name}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        Address:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.party.addressLine1}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        GSTIN/UIN:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.party.gstNo}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        Party Jangad No:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.partyJangadNo}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        Date:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {moment(this.state.props.data.jangad.createdAt).format(
                          "DD-MM-YYYY"
                        )}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        Time:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {moment(this.state.props.data.jangad.createdAt).format(
                          "hh:mm:ss A"
                        )}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        {this.props.t("Category Name")}:
                      </h5>{" "}
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.category.name}
                      </p>
                    </div>
                    <div>
                      <h5 className="fw-bold d-inline text-black pt-2">
                        Challan No:
                      </h5>
                      <p className="d-inline fs-5 ps-2">
                        {this.state.props.data.mainJangad.id}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-3 px-3">
                  <div className="table-responsive">
                    <table className="table table-bordered background-light1 text-center">
                      <thead className="fs-5 fw-bold">
                        <tr>
                          <th>{this.props.t("Jangad ID")}</th>
                          <th>{this.props.t("Pieces")}</th>
                          <th>{this.props.t("Weight Crt")}</th>
                          <th>{this.props.t("Rate")}</th>
                          <th>{this.props.t("Amount")}</th>
                          <th>{this.props.t("Remarks")}</th>
                        </tr>
                      </thead>
                      <tbody className="fs-5 foo1">
                        <tr key={this.state.props.data.id}>
                          <td>{this.state.props.data.mainJangad.name}</td>

                          <td>{this.state.props.data.jangad.pieces}</td>
                          <td>{this.state.props.data.jangad.weight}</td>
                          <td>
                            {
                              this.state.props.data.mainJangad.party
                                .duplicateRate
                            }
                          </td>
                          <td>
                            {this.state.props.data.mainJangad.party
                              .duplicateRate *
                              this.state.props.data.jangad.weight}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="px-3">
                  <h4 className="fw-bold text-black pt-2">
                    Terms and Conditions
                  </h4>
                  <p className="fs-5 text-black">
                    {this.state.organizations.tac}
                  </p>
                  <h4 className="fw-bold text-black pt-2">Declaration</h4>
                  <p className="fs-5 text-black">
                    {this.state.organizations.declaration}
                  </p>
                  <div className="d-sm-flex d-block justify-content-between">
                    <div>
                      <h5>
                        For <strong> Receiver:</strong>
                      </h5>
                    </div>
                    <div>
                      <h5>
                        for
                        <strong> P3Y Diamond Tech</strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            <div className="row my-5">
              <div className="col-12 text-end">
                <div className="btn-group">
                  <Button
                    className="py-2 px-2 border-0 bg-success rounded me-3"
                    onClick={e => window.print(e.preventDefault())}
                  >
                    <img
                      src="images/dashboard-images/printwhite.svg"
                      className="text-white"
                      alt="print"
                    />
                  </Button>
                  <Button
                    color="primary"
                    className="fs-4 px-5 no-print"
                    type="submit"
                    onClick={() => window.print()}
                  >
                    Print
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(DeliveryChallan);
